import { ApiError } from "../../api/client";

export type Sending = { enabled: boolean; on: boolean; label: string; changedAt: string | null; supportMailbox: string | null };
export type Mailboxes = { connected: boolean; status: string; sending: Sending; canSend: boolean; mailboxes: { address: string; unread: number | null }[] };
export type Summary = { id: string; conversationId: string | null; subject: string; from: string | null; fromName: string | null; receivedAt: string; preview: string; isRead: boolean; hasAttachments: boolean };
export type Full = Summary & { to: string[]; cc: string[]; body: string };
export type Opened = Full & { thread: Full[] };
export type DraftContext = { orgId?: string; quoteId?: string; shipmentId?: string; ticketId?: string };
export type Draft = {
  id: string;
  mailbox: string;
  kind: "new" | "reply" | "forward";
  sourceMessageId: string | null;
  to: string[];
  cc: string[];
  subject: string;
  bodyHtml: string;
  html: string;
  templateId: string | null;
  context: DraftContext;
  status: "draft" | "sending" | "sent" | "failed";
  lastError: string | null;
  externalRecipients: string[];
  sentAt: string | null;
  createdAt: string;
  updatedAt: string;
};
export type Template = { id: string; name: string; subject: string; bodyHtml: string; variables: string[]; updatedAt: string };
export type TemplateList = { templates: Template[]; variables: readonly { key: string; label: string }[] };
export type Rendered = { subject: string; bodyHtml: string; missing: string[]; unknown: string[] };

export const MAILBOXES_KEY = ["console", "mailboxes"] as const;
export const TEMPLATES_KEY = ["console", "email", "templates"] as const;
export const when = new Intl.DateTimeFormat("en-US", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
export const errorText = (e: unknown) => (e instanceof ApiError ? e.message : "Something went wrong. Try again.");
/** FlexFreight's own domains come from the server's mailboxes; anything else is an outside recipient. */
export const splitAddresses = (s: string) => s.split(/[\s,;]+/).map((a) => a.trim().toLowerCase()).filter(Boolean);
/** Server-rendered, sanitised HTML is shown in a sandboxed frame: no scripts, no same-origin access. */
export const previewDoc = (html: string) =>
  `<!doctype html><html><head><meta charset="utf-8"><meta http-equiv="Content-Security-Policy" content="default-src 'none'; style-src 'unsafe-inline'"><style>body{font:15px/1.5 system-ui,sans-serif;margin:12px;color:#111;background:#fff}a{color:#2b5bd7}</style></head><body>${html}</body></html>`;
